import { Chip } from '@material-ui/core';
import { SETVIImage } from '@setvi/shared/components';
import { StepperContainer, StepItem, StepContent, StepLabel } from '../style';
import type { Step } from '../types';

interface StepperSidebarProps {
  steps: Step[];
  activeStep: number;
  onStepClick: (index: number) => void;
}

export const StepperSidebar = ({
  steps,
  activeStep,
  onStepClick
}: StepperSidebarProps) => (
  <StepperContainer>
    {steps.map((s, index) => {
      const isActive = activeStep === index;
      return (
        <StepItem
          key={s.id}
          onClick={() => onStepClick(index)}
          style={{
            borderLeft: isActive ? '8px solid #1E96FC' : '8px solid transparent'
          }}>
          <SETVIImage
            src={s.icon}
            alt="step icon"
            width={s?.iconWidth || 24}
            height={s?.iconHeight || 24}
          />

          <StepContent>
            <StepLabel
              style={{
                fontWeight: isActive ? 600 : 400
              }}>
              {s.label}
            </StepLabel>
            {!s?.completed && (
              <Chip
                label="Missing data"
                style={{
                  color: '#FA2020',
                  borderRadius: 120,
                  backgroundColor: '#FED2D2',
                  fontWeight: 'bold',
                  height: '24px'
                }}
              />
            )}
          </StepContent>
        </StepItem>
      );
    })}
  </StepperContainer>
);
